export interface IAudit {
  message: string;
  token: string;
  isIframe: boolean;
}

export const initialState: IAudit = {
  message: '',
  token: '123',
  isIframe: false,
};
